import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Accordion, Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Users } from '../api/Users';
import Avatar from '../components/Avatar'
import { useAuth } from '../contexts/auth'
import { useFullScreenLoader } from '../contexts/fullScreenLoader';
import { useToasts } from '../contexts/toasts';

class Credentials {
  oldPassword: string;
  newPassword: string;

  constructor() {
    this.oldPassword = "";
    this.newPassword = "";
  }
}

export default function Account() {
  const { t } = useTranslation();
  const { loggedUser } = useAuth();

  const [credentials, setCredentials] = useState<Credentials>(new Credentials());
  const [validated, setValidated] = useState<boolean>();

  const { showLoader, hideLoader } = useFullScreenLoader();
  const { showToast } = useToasts();

  const handleFieldChange = (field: keyof Credentials) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setCredentials({
      ...credentials,
      [field]: value,
    });
  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (form.checkValidity() === true) {
      showLoader!();
      setValidated(false);

      Users.changePassword(credentials.oldPassword, credentials.newPassword)
        .then(
          () => {
            hideLoader!();
            showToast!('account-success', 'Password updated successfully!', 'Password success', 'success');
            setCredentials(new Credentials());
          },
          (err) => {
            hideLoader!();
            const message = err.response?.data?.message || err.message;
            const status = err.response?.status;
            showToast!('account-error', message, `Account Error ${status ? `(${status})` : ''}`, 'danger');
          }
        )
    }
  }

  return (
    <Container>
      <Card>
        <Card.Body>
          <div className="d-flex align-items-center mb-3">
            <div className="pe-3">
              <Avatar size="lg" user={loggedUser!} />
            </div>
            <Col>
              <h4 className="mb-1">{loggedUser?.firstname} {loggedUser?.lastname}</h4>
              <h6 className="text-muted mb-0 text-uppercase">{loggedUser?.role}</h6>
            </Col>
          </div>

          <Accordion>
            <Accordion.Item eventKey="change-password">
              <Accordion.Header>
                <FontAwesomeIcon icon={solid('key')} />
                <span className="ms-3">{t('account.changePassword')}</span>
              </Accordion.Header>
              <Accordion.Body>
                <Form validated={validated} noValidate onSubmit={handleSubmit}>
                  <Form.Group as={Row} className="mb-3" controlId="old-password">
                    <Col md={4}>
                      <Form.Label>{t('account.currentPassword')}</Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="password" size="sm" placeholder={t('account.currentPassword')} value={credentials.oldPassword} onChange={handleFieldChange('oldPassword')} required />
                      <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('account.currentPassword') })}</Form.Control.Feedback>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3" controlId="new-password">
                    <Col md={4}>
                      <Form.Label>{t('account.newPassword')}</Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="password" size="sm" placeholder={t('account.newPassword')} value={credentials.newPassword} onChange={handleFieldChange('newPassword')} minLength={8} required />
                      <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('account.newPassword') })}</Form.Control.Feedback>
                    </Col>
                  </Form.Group>

                  <Row className="justify-content-end">
                    <Col md={2}>
                      <Button className="w-100" size="sm" variant="success" type="submit">{t('common.confirm')}</Button>
                    </Col>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Body>
      </Card>
    </Container>
  )
}